import { render, staticRenderFns } from "./AddCart.vue?vue&type=template&id=c13b6ad6&scoped=true&"
import script from "./AddCart.vue?vue&type=script&lang=js&"
export * from "./AddCart.vue?vue&type=script&lang=js&"
import style0 from "./AddCart.vue?vue&type=style&index=0&id=c13b6ad6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13b6ad6",
  null
  
)

export default component.exports